class TypeChecker {
  // Check if value is an array and not empty
  static isArray(value) {
      return Array.isArray(value) && value.length > 0;
  }

  // Check if value is an object (excluding arrays and null)
  static isObject(value) {
      return value !== null && typeof value === "object" && !Array.isArray(value);
  }

  // Check if value is a string and not empty
  static isString(value) {
      return typeof value === "string" && value.trim().length > 0;
  }

  // Check if value is a number (excluding NaN)
  static isNumber(value) {
      return typeof value === "number" && !isNaN(value);
  }

  // Check if value is empty (null, undefined, empty array, empty string, or empty object)
  static isEmpty(value) {
      if (value == null) return true; // null or undefined
      if (typeof value === "string" && value.trim().length === 0) return true; // Empty string
      if (Array.isArray(value) && value.length === 0) return true; // Empty array
      if (this.isObject(value) && Object.keys(value).length === 0) return true; // Empty object
      return false;
  }
}

// Export the class for use in other files
module.exports = TypeChecker;
